import * as React from "react";
import type { TypeCheckboxProps } from "./types/CheckboxTypes";
import CheckboxHybrid from "./CheckboxHybrid";

/**
 * Checkbox component. Automatically routes between the Tailwind implementation
 * (preferred) and the styled-components implementation (for consumers using
 * system props or a styled() extension).
 */
const Checkbox = React.forwardRef<HTMLInputElement, TypeCheckboxProps>(
  (props, ref) => <CheckboxHybrid {...props} ref={ref} />
);

Checkbox.displayName = "Checkbox";
export default Checkbox;
